import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsGridComponent } from './transport-interventions-grid.component';
import {TransportInterventionsToolbarModule} from '../transport-interventions-toolbar/transport-interventions-toolbar.module';
import {TabModule} from '../../tab/tab.module';
import {DxDataGridModule, DxPopoverModule} from 'devextreme-angular';
import {GridTitleModule} from 'shared';
import {IconModule} from '@visurel/iconify-angular';
import {TransportInterventionsReportModule} from '../transport-interventions-report/transport-interventions-report.module';



@NgModule({
  declarations: [TransportInterventionsGridComponent],
    imports: [
        CommonModule,
        TransportInterventionsToolbarModule,
        TabModule,
        DxDataGridModule,
        GridTitleModule,
        IconModule,
        DxPopoverModule,
        TransportInterventionsReportModule
    ],
  exports: [TransportInterventionsGridComponent]
})
export class TransportInterventionsGridModule { }
